import React from 'react';
import {Link} from "react-router-dom";

function BlogSidebar({categories, activeCategoryLink, searchQuery, onSearchChange}) {

    const categoryEntries = categories ? Array.from(categories.entries()) : [];
    const isAllActive = !activeCategoryLink;

    return (
        <div className="blog2-sidebar">
            <p className="blog2-sidebar-text">
                Znajdziesz tu praktyczne porady i aktualności ze świata leasingu, finansowania
                pojazdów oraz zarządzania flotą firmową i prywatną.
            </p>

            <div className="blog2-search">
                <input
                    type="text"
                    placeholder="Szukaj artykułu"
                    value={searchQuery}
                    onChange={e => onSearchChange(e.target.value)}
                    className="blog2-search-input"
                />
                <span className="blog2-search-icon">
                    <i className="fa fa-search"/>
                </span>
            </div>

            <div className="blog2-categories">
                <p className="blog2-categories-label">kategorie</p>
                <ul className="blog2-categories-list">
                    <li>
                        {isAllActive
                            ? <span className="blog2-category-link blog2-category-link--active">Wszystkie artykuły</span>
                            : <Link to="/blog" className="blog2-category-link">Wszystkie artykuły</Link>
                        }
                    </li>
                    {categoryEntries.map(([categoryLink, categoryName]) => (
                        <li key={categoryLink}>
                            {categoryLink === activeCategoryLink
                                ? <span className="blog2-category-link blog2-category-link--active">{categoryName}</span>
                                : <Link to={`/blog/category/${categoryLink}`} className="blog2-category-link">{categoryName}</Link>
                            }
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default BlogSidebar;
